module.exports = __webpack_public_path__ + "img/related-icon.babd563d.png";